module.exports = __webpack_public_path__ + "static/media/search.f8ba8bd5.svg";